export class SortingItem {
  label: string;
  field: 'name asc' | 'name desc' | 'most_discontinued' | 'best_seller' | 'latest_arrival' | 'styles' | 'assortments';

  constructor(s?: Partial<SortingItem>) {
    if (s) {
      Object.assign(<SortingItem>this, s)
    }
  }
}
